var exports = {
  "CR": "CustomStatusModal.module__modalRoot___UjE4UT",
  "_l": "CustomStatusModal.module__previewSection___UjE4UT",
  "uG": "CustomStatusModal.module__statusInputWrapper___UjE4UT",
  "Dq": "CustomStatusModal.module__characterCount___UjE4UT",
  "DY": "CustomStatusModal.module__emojiTriggerButton___UjE4UT",
  "Ow": "CustomStatusModal.module__emojiPreviewImage___UjE4UT",
  "VK": "CustomStatusModal.module__emojiTriggerButtonActive___UjE4UT",
  "J7": "CustomStatusModal.module__clearButtonIcon___UjE4UT",
  "qr": "CustomStatusModal.module__footer___UjE4UT",
  "x3": "CustomStatusModal.module__expirationSelectWrapper___UjE4UT",
  "uD": "CustomStatusModal.module__expirationLabel___UjE4UT",
  "S2": "CustomStatusModal.module__expirationSelect___UjE4UT",
};

module.exports = exports;
